export default __webpack_public_path__ + "static/media/JULIA.207079b6.png";